(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Kik-hotspot-image-text"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const video = document.getElementById('hotspotVideo');
  const image = document.getElementById('hotspotImage');
  const hotspots = document.querySelectorAll('.hotspot-point');

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting && video) {
        video.play().catch(() => {});
      }
    });
  }, { threshold: 0.3 });

  if (video) {
    observer.observe(video);
    video.addEventListener('ended', () => {
      video.style.display = 'none';
      if (image) image.style.display = 'block';
      hotspots.forEach(h => h.style.display = 'block');
    });
  } else {
    if (image) image.style.display = 'block';
    hotspots.forEach(h => h.style.display = 'block');
  }

  // Removed tooltip creation and hover logic

  hotspots.forEach(hotspot => {
    hotspot.addEventListener('click', () => {
      const title = hotspot.dataset.title || '';
      const text = hotspot.dataset.text || '';
      const button = hotspot.dataset.button || '';
      const link = hotspot.dataset.link || '';

      const titleEl = document.getElementById('hotspotTitle');
      const descEl = document.getElementById('hotspotDescription');
      const btnWrap = document.getElementById('hotspotButtonWrapper');

      if (titleEl) titleEl.innerHTML = `<strong>${title}</strong>`;
      if (descEl) descEl.textContent = text;

      if (btnWrap) {
        if (button && link) {
          btnWrap.innerHTML = `<a href="${link}" class="hotspot-btn">${button}</a>`;
        } else {
          btnWrap.innerHTML = '';
        }
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kiks-gallery-grid"] && !Shopify.designMode) return;
  try {
    
  class KiksGalleryGrid extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
  
    init() {
      this.gallery = this.querySelector('.kiks-gallery__grid');
      if (!this.gallery) return;
  
      // Check if we should initialize slider based on screen width
      this.checkAndInitSlider();
      
      // Listen for window resize
      window.addEventListener('resize', this.debounce(() => {
        this.checkAndInitSlider();
      }, 250));
    }
  
    checkAndInitSlider() {
      const isMobile = window.innerWidth <= 768;
      const desktopSliderEnabled = this.gallery.dataset.desktopSlider === 'true';
      const mobileSliderEnabled = this.gallery.dataset.mobileSlider === 'true';
      
      // Destroy existing Flickity instance if it exists
      if (this.slideshow && typeof this.slideshow.destroy === 'function') {
        this.slideshow.destroy();
        this.slideshow = null;
      }
  
      // Initialize slider if enabled for current screen size
      if ((isMobile && mobileSliderEnabled) || (!isMobile && desktopSliderEnabled)) {
        const slidesToShow = isMobile 
          ? parseInt(this.gallery.dataset.slidesShowMobile) 
          : parseInt(this.gallery.dataset.slidesShowDesktop);
  
        // Get navigation settings based on screen size
        const showArrows = isMobile 
          ? this.gallery.dataset.enableArrowsMobile === 'true'
          : this.gallery.dataset.enableArrowsDesktop === 'true';
        
        const showDots = isMobile
          ? this.gallery.dataset.enableDotsMobile === 'true'
          : this.gallery.dataset.enableDotsDesktop === 'true';
  
        const args = {
          cellAlign: 'left',
          contain: true,
          pageDots: showDots,
          prevNextButtons: showArrows,
          draggable: true,
          wrapAround: this.gallery.dataset.enableLoop === 'true',
          autoPlay: this.gallery.dataset.autoplaySpeed ? parseInt(this.gallery.dataset.autoplaySpeed) : false,
          groupCells: slidesToShow,
          cellSelector: '.grid__item'
        };
  
        this.slideshow = new theme.Slideshow(this.gallery, args);
      }
    }
  
    debounce(fn, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          fn(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }
  }
  
  customElements.define('kiks-gallery-grid', KiksGalleryGrid);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kiks-sticky-navbar"] && !Shopify.designMode) return;
  try {
    
   class KiksStickyNavbar extends HTMLElement {
    constructor() {
      super();
      this.navItems = this.querySelectorAll('[data-nav-item]');
      this.enableSticky = this.dataset.enableSticky === 'true';
      this.navbarTop = 0;
      this.mainContent = document.getElementById('MainContent');
      this.sections = [];
      this.maxSectionIndex = Math.max(...Array.from(this.navItems).map(item => 
        parseInt(item.getAttribute('data-section-index')) || 0
      ));
      
      // Add scroll tracking variables
      this.lastScrollTop = 0;
      
      // Bind methods that will be used as event listeners
      this.handleResize = this.handleResize.bind(this);
      this.handleScroll = this.handleScroll.bind(this);
      
      // Wait for the document to be fully loaded
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init());
      } else {
        this.init();
      }

      // Also check after a short delay to catch dynamically loaded sections
      setTimeout(() => this.initSections(), 500);
    }

    initSections() {
      if (this.mainContent) {
        // Get all sections in the main content
        const allSections = Array.from(this.mainContent.querySelectorAll('.shopify-section, [id^="shopify-section"]'));
        
        // Filter out any nested sections to avoid duplicates
        const uniqueSections = allSections.filter(section => {
          const parent = section.parentElement.closest('.shopify-section, [id^="shopify-section"]');
          return !parent || parent === section;
        });

        // Mark sections with indices
        uniqueSections.forEach((section, index) => {
          const sectionIndex = index + 1;
          section.setAttribute('data-nav-section-index', sectionIndex);
        });

        // Store sections for later use
        this.sections = uniqueSections;

        // Verify nav item indices against available sections
        this.navItems.forEach(item => {
          const index = parseInt(item.getAttribute('data-section-index'));
          const title = item.textContent.trim();
          const targetSection = this.sections[index - 1];
        });
      }
    }

    init() {
      this.initSections();
      this.setupEventListeners();
      this.checkActiveSection();
      if (this.enableSticky) {
        this.updateNavbarPosition();
        // Add resize listener
        window.addEventListener('resize', this.handleResize);
      }
    }

    setupEventListeners() {
      // Click event for smooth scrolling
      this.navItems.forEach(item => {
        item.addEventListener('click', (e) => {
          const requestedIndex = parseInt(item.getAttribute('data-section-index'));
          
          // Find section by index (1-based)
          const targetSection = this.sections[requestedIndex - 1];
          
          if (targetSection) {
            // Get all sticky elements' heights
            const header = document.querySelector('.site-header');
            const headerHeight = header ? header.offsetHeight : 0;
            const navbarHeight = this.offsetHeight;
            const totalOffset = headerHeight + (this.classList.contains('is-sticky') ? navbarHeight : 0);
            
            // Calculate target position
            const targetPosition = this.getAbsoluteOffsetTop(targetSection) - totalOffset;
            
            // Smooth scroll to target position
            window.scrollTo({
              top: targetPosition,
              behavior: 'smooth'
            });
            
            this.setActiveItem(item);
          } else {
            console.error(`Section ${requestedIndex} not found. Available sections:`, 
              this.sections.map((s, i) => ({
                index: i + 1,
                id: s.id
              }))
            );
          }
        });
      });

      // Scroll event handling
      window.addEventListener('scroll', this.handleScroll);
    }

    handleScroll() {
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          this.checkActiveSection();
          if (this.enableSticky) {
            this.handleStickyBehavior();
            this.handleHeaderVisibility();
          }
          this.ticking = false;
        });
        this.ticking = true;
      }
    }

    handleHeaderVisibility() {
      // Only handle header visibility when navbar is sticky
      if (!this.classList.contains('is-sticky')) {
        document.body.classList.remove('hide-main-header');
        return;
      }

      const currentScroll = window.pageYOffset;
      
      // Scrolling down
      if (currentScroll > this.lastScrollTop) {
        document.body.classList.add('hide-main-header');
      }
      // Scrolling up
      else if (currentScroll < this.lastScrollTop) {
        document.body.classList.remove('hide-main-header');
      }
      
      this.lastScrollTop = currentScroll;
    }

    handleStickyBehavior() {
      const scrollTop = window.pageYOffset;
      const header = document.querySelector('.site-header');
      const headerHeight = header ? header.offsetHeight : 0;
      
      // Add sticky class when scrolling reaches the navbar
      if (scrollTop > (this.navbarTop - headerHeight - 1)) { // Subtract 1px to prevent flickering
        if (!this.classList.contains('is-sticky')) {
          this.classList.add('is-sticky');
          // Update position after adding sticky to handle any layout shifts
          requestAnimationFrame(() => this.updateNavbarPosition());
        }
      } else {
        if (this.classList.contains('is-sticky')) {
          this.classList.remove('is-sticky');
          // Update position after removing sticky
          requestAnimationFrame(() => this.updateNavbarPosition());
        }
      }
    }

    // Helper function to get absolute offset top of an element
    getAbsoluteOffsetTop(element) {
      let offsetTop = 0;
      while (element) {
        offsetTop += element.offsetTop;
        element = element.offsetParent;
      }
      return offsetTop;
    }

    // Handle window resize
    handleResize() {
      if (this.enableSticky) {
        requestAnimationFrame(() => {
          this.updateNavbarPosition();
          this.handleStickyBehavior();
        });
      }
    }

    // Update navbar position
    updateNavbarPosition() {
      // Temporarily remove sticky to get true position
      const wasSticky = this.classList.contains('is-sticky');
      if (wasSticky) {
        this.classList.remove('is-sticky');
      }

      // Get the true position
      this.navbarTop = this.getBoundingClientRect().top + window.pageYOffset;

      // Restore sticky if it was removed
      if (wasSticky) {
        this.classList.add('is-sticky');
      }
    }

    checkActiveSection() {
      if (!this.sections.length) return;
      
      // Get current sticky elements' heights
      const header = document.querySelector('.site-header');
      const headerHeight = header ? header.offsetHeight : 0;
      const navbarHeight = this.offsetHeight;
      const totalOffset = headerHeight + (this.classList.contains('is-sticky') ? navbarHeight : 0);
      
      // Get current scroll position with offset
      const scrollPosition = window.scrollY + totalOffset + 100; // Add 100px threshold for better detection
      const viewportHeight = window.innerHeight;
      const viewportBottom = window.scrollY + viewportHeight;

      // Calculate visibility for each section
      const visibilityData = this.sections.map((section, index) => {
        const rect = section.getBoundingClientRect();
        const sectionTop = window.scrollY + rect.top;
        const sectionHeight = rect.height;
        const sectionBottom = sectionTop + sectionHeight;
        
        // Calculate how much of the section is visible
        const visibleTop = Math.max(sectionTop, window.scrollY + totalOffset);
        const visibleBottom = Math.min(sectionBottom, viewportBottom);
        const visibleHeight = Math.max(0, visibleBottom - visibleTop);
        const visibilityRatio = visibleHeight / sectionHeight;

        return {
          index,
          section,
          sectionTop,
          sectionBottom,
          visibilityRatio,
          isInView: visibilityRatio > 0
        };
      });

      // Find the most visible section
      let mostVisibleSection = null;
      let maxVisibility = 0;

      visibilityData.forEach((data) => {
        if (data.isInView && data.visibilityRatio > maxVisibility) {
          maxVisibility = data.visibilityRatio;
          mostVisibleSection = data.section;
        }
      });

      // Special case: if we're at the top of the page, activate the first section
      if (window.scrollY <= 10) {
        mostVisibleSection = this.sections[0];
      }
      
      // Special case: if we're at the bottom of the page, activate the last section
      if ((window.innerHeight + window.scrollY) >= document.documentElement.scrollHeight - 10) {
        mostVisibleSection = this.sections[this.sections.length - 1];
      }

      if (mostVisibleSection) {
        // Find the nav item that corresponds to this section
        const sectionIndex = this.sections.indexOf(mostVisibleSection) + 1;
        const activeNavItem = Array.from(this.navItems).find(item => 
          parseInt(item.getAttribute('data-section-index')) === sectionIndex
        );

        if (activeNavItem) {
          this.setActiveItem(activeNavItem);
        }
      }
    }

    setActiveItem(activeItem) {
      if (!activeItem) return;

      // Remove active class from all items
      this.navItems.forEach(item => {
        if (item !== activeItem && item.classList.contains('is-active')) {
          item.classList.remove('is-active');
        }
      });

      // Add active class to current item if not already active
      if (!activeItem.classList.contains('is-active')) {
        activeItem.classList.add('is-active');

        // Get the navbar items container
        const navbarContainer = this.querySelector('.kiks-sticky-navbar__items');
        if (navbarContainer) {
          // Calculate the center position
          const containerWidth = navbarContainer.offsetWidth;
          const itemWidth = activeItem.offsetWidth;
          const itemLeft = activeItem.offsetLeft;
          const scrollLeft = itemLeft - (containerWidth / 2) + (itemWidth / 2);

          // Smooth scroll the navbar horizontally
          navbarContainer.scrollTo({
            left: scrollLeft,
            behavior: 'smooth'
          });
        }
      }
    }
  }

  customElements.define('kiks-sticky-navbar', KiksStickyNavbar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kiks-text-with-icons"] && !Shopify.designMode) return;
  try {
    
      class TextWithIconsSlider extends HTMLElement {
        constructor() {
          super();
          this.slider = null;
          this.init();
          this.handleResize = this.handleResize.bind(this);
        }

        getResponsiveOptions() {
          const windowWidth = window.innerWidth;
          let itemsToShow, itemsPerSlide;

          if (windowWidth <= 430) {
            // Mobile settings
            itemsToShow = parseInt(this.dataset.itemsToShowMobile) || 1;
            itemsPerSlide = parseInt(this.dataset.itemsPerSlideMobile) || 1;
          } else if (windowWidth <= 820) {
            // Tablet settings
            itemsToShow = parseInt(this.dataset.itemsToShowTablet) || 2;
            itemsPerSlide = parseInt(this.dataset.itemsPerSlideTablet) || 1;
          } else {
            // Desktop settings
            itemsToShow = parseInt(this.dataset.itemsToShow) || 3;
            itemsPerSlide = parseInt(this.dataset.itemsPerSlide) || 1;
          }

          return { itemsToShow, itemsPerSlide };
        }

        handleResize() {
          if (!this.slider) return;
          
          const { itemsToShow, itemsPerSlide } = this.getResponsiveOptions();
          
          // Update slider options
          this.slider.options.groupCells = itemsPerSlide;
          
          // Force slider refresh
          this.slider.resize();
          
          // Update cell widths
          const cells = this.slider.getCellElements();
          cells.forEach(cell => {
            cell.style.width = `calc(100% / ${itemsToShow})`;
          });
        }

        init() {
          const sliderEnabled = this.dataset.enableSlider === 'true';
          if (!sliderEnabled) return;

          const sliderContainer = this.querySelector('.text-with-icons__blocks');
          if (!sliderContainer) return;

          const { itemsToShow, itemsPerSlide } = this.getResponsiveOptions();

          const options = {
            cellAlign: 'left',
            contain: true,
            pageDots: true,
            prevNextButtons: true,
            wrapAround: this.dataset.enableLoop === 'true',
            autoPlay: this.dataset.enableAutoplay === 'true' ? parseInt(this.dataset.autoplaySpeed) : false,
            groupCells: itemsPerSlide,
            cellSelector: '.text-with-icons__block',
            adaptiveHeight: false,
            draggable: true
          };

          // Initialize Flickity
          this.slider = new Flickity(sliderContainer, options);

          // Add resize handler
          window.addEventListener('resize', this.handleResize);

          // Initial resize to set correct sizes
          this.handleResize();
        }

        disconnectedCallback() {
          window.removeEventListener('resize', this.handleResize);
          if (this.slider) {
            this.slider.destroy();
          }
        }
      }

      customElements.define('text-with-icons-slider', TextWithIconsSlider);
    
  } catch(e) { console.error(e); }
})();
})();
